import { fragments } from '@/gql'
const {gql} = require('graphql-tag')
export default gql`
  mutation replacePosterFrames ($input: replacePosterFramesInput!) {
    replacePosterFrames (input: $input) {
      ...filmMasterDetail
    }
  }
  ${fragments.filmMasterDetail}
  ${fragments.stripDetail}
  ${fragments.filmHost}
  ${fragments.filmMasterPosterFrames}
  ${fragments.filmFiles}
  ${fragments.filmFileDetail}
  ${fragments.artworkDetails}
`
